module.exports = __webpack_public_path__ + "img/imgZXGH(33).3a35eb07.png";